import { functionUtils } from 'utils';
import ConfirmCloseFormPIIPopup from './popup';

const ConfirmCloseFormPIIModal = ({ isShow, action, actionClose }) => {
  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
  };

  return (
    <ConfirmCloseFormPIIPopup
      isOpen={isShow}
      onClose={handleOnClose}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1068}
      zIndexModal={1069}
    />
  );
};

export default ConfirmCloseFormPIIModal;
